/**
 * Classes utilitaires de transition
 */
export const TRANSITIONS_STYLES = `
  /* Transitions pour les widgets */
  .ringado-widget-transition {
    transition: all 0.3s ease;
  }

  .ringado-widget-enter {
    opacity: 0;
    transform: scale(0.75) translateY(16px);
  }

  .ringado-widget-enter-active {
    transition: all 0.3s ease;
  }

  .ringado-widget-enter-to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
`;
